<template>
    <!--<div class="mt-8 w-full mx-auto grid grid-cols-1 gap-6 sm:px-6 lg:px-8 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-12">-->
    <div class="px-8 my-8 grid grid-cols-1 gap-6 lg:grid-flow-col-dense lg:grid-cols-12 bg-gray-50">
        <slot></slot>
    </div>
</template>